export function buildSuggestedDraftsKey(conversationId: string, itemId: string, addinTitleId: string): string {
    return `${conversationId}-${itemId}-${addinTitleId}`;
}
